import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UserIcon from "../../assets/images/icon/profile.png";
import { useSidebarData } from "../../hooks/useSidebarData";
import SidebarPanelContent from "../common/SidebarPanelContent";
import AuthService from "../../services/auth";
import { disconnectGlobalSocket } from "../../services/socket";
import { toastError } from "../Toast";

const MobileSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { username, imagePreview } = useSidebarData();
  const [imgError, setImgError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    setImgError(false);
  }, [imagePreview]);

  const toggleOffCanvas = () => setIsOpen((v) => !v);

  // Close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen]);

  const handleLogOut = async () => {
    try {
      await AuthService.logout();
      try { indexedDB.deleteDatabase("linko_transcribe_db"); } catch (_e) { }
      disconnectGlobalSocket(dispatch);
      localStorage.clear();
      window.dispatchEvent(new Event("authChanged"));
      navigate("/login");
    } catch (error) {
      toastError(error?.response?.data?.message || "Logout failed. Please try again.");
    }
  };

  const handlePlanClick = () => {
    setIsOpen(false);
    navigate("/plans", { state: { tab: "plans" } });
  };

  return (
    <div className="md:hidden relative">
      {/* Toggle Button — profile icon */}
      <button onClick={toggleOffCanvas} className="z-50 focus:outline-none" aria-label="Toggle menu">
        <div
          className="rounded-full flex items-center justify-center flex-shrink-0"
          style={{
            width: "40px",
            height: "40px",
            background: "linear-gradient(to top right, #C7BFE5 0%, #904DB0 100%)",
          }}
        >
          {imagePreview && !imgError ? (
            <img
              src={imagePreview}
              alt="Profile"
              className="w-full h-full object-cover rounded-full"
              onError={() => setImgError(true)}
            />
          ) : (
            <span
              className="font-museo font-extrabold uppercase text-white leading-none select-none"
              style={{ fontSize: "16px" }}
            >
              {(username || "U").trim().charAt(0).toUpperCase() || "U"}
            </span>
          )}
        </div>
      </button>

      {/* Full-screen on mobile, fixed-width panel on tablet */}
      {isOpen && (
        <div
          ref={panelRef}
          className="fixed top-0 left-0 h-screen flex flex-col z-50 overflow-y-auto w-screen sm:w-[280px]"
          style={{ background: "linear-gradient(225deg, #1A0E3E 30%, #4F2A71 75%, #904DB0 100%)" }}
        >
          {/* Close button — mobile full-screen only */}
          <button
            onClick={() => setIsOpen(false)}
            className="sm:hidden absolute top-4 right-4 text-[#C7BFE5] focus:outline-none"
            aria-label="Close menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <SidebarPanelContent onLogOut={handleLogOut} onPlanClick={handlePlanClick} />
        </div>
      )}
    </div>
  );
};

export default MobileSidebar;
